import React from "react";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import { REGIONAL_HUBS } from "@/data/regionalHubs";

const TYPE_STYLES = {
  farm: { color: "#3B8268", fill: "#3B8268", label: "Farm" },
  mining: { color: "#D95D39", fill: "#D95D39", label: "Mining / FIFO" },
  tourism: { color: "#9B5DE5", fill: "#9B5DE5", label: "Tourism" },
  metro: { color: "#D9423E", fill: "#D9423E", label: "Metro (NOT eligible)" },
};

export function EligibleZonesMap({ t }) {
  return (
    <div className="max-w-5xl mx-auto" data-testid="eligible-zones-map">
      <div className="mb-6">
        <h3 className="font-heading font-bold text-2xl lg:text-3xl text-[#292524] mb-2">
          {t.map.title}
        </h3>
        <p className="text-[#57534E]">{t.map.sub}</p>
      </div>

      {/* Legend */}
      <div className="flex flex-wrap gap-2 mb-4" data-testid="map-legend">
        {[
          { key: "farm", text: t.map.legend_farm },
          { key: "mining", text: t.map.legend_mining },
          { key: "tourism", text: t.map.legend_tourism },
          { key: "metro", text: t.map.legend_metro },
        ].map((it) => (
          <div
            key={it.key}
            className="inline-flex items-center gap-2 bg-white border border-[#EAE5DB] rounded-xl px-3 py-1.5 text-xs font-semibold text-[#292524]"
          >
            <span
              className="inline-block w-2.5 h-2.5 rounded-full"
              style={{ backgroundColor: TYPE_STYLES[it.key].color }}
            />
            {it.text}
          </div>
        ))}
      </div>

      {/* Map */}
      <div className="rounded-2xl overflow-hidden border border-[#EAE5DB] shadow-sm" style={{ height: 560 }}>
        <MapContainer
          center={[-25.2744, 133.7751]}
          zoom={4}
          scrollWheelZoom={true}
          style={{ height: "100%", width: "100%" }}
          data-testid="leaflet-map"
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {REGIONAL_HUBS.map((hub) => {
            const style = TYPE_STYLES[hub.type] || TYPE_STYLES.farm;
            return (
              <CircleMarker
                key={`${hub.name}-${hub.postcode}`}
                center={[hub.lat, hub.lng]}
                radius={hub.type === "metro" ? 7 : 9}
                pathOptions={{
                  color: style.color,
                  fillColor: style.fill,
                  fillOpacity: 0.65,
                  weight: 2,
                }}
              >
                <Popup>
                  <div style={{ fontFamily: "Manrope, sans-serif", minWidth: 180 }}>
                    <div style={{ fontWeight: 700, color: "#292524", fontSize: 14 }}>
                      {hub.name}
                    </div>
                    <div style={{ color: "#78716C", fontSize: 11, marginTop: 2 }}>
                      {hub.state} · {String(hub.postcode).padStart(4, "0")}
                    </div>
                    <div
                      style={{
                        marginTop: 8,
                        display: "inline-block",
                        padding: "2px 8px",
                        borderRadius: 8,
                        backgroundColor: `${style.color}20`,
                        color: style.color,
                        fontWeight: 700,
                        fontSize: 11,
                      }}
                    >
                      {style.label}
                    </div>
                  </div>
                </Popup>
              </CircleMarker>
            );
          })}
        </MapContainer>
      </div>
    </div>
  );
}
